import { FC } from 'react';
import UiBox, { type IBoxProps as IUiBoxProps } from '@srm/ui/box';
import { formulaTraceAttrs } from '@/context/DocumentFormulaTraceContext';
import { ConfigService } from '@/configuration/services/configService';

export interface IBoxProps extends Omit<IUiBoxProps, 'collapseEnabled' | 'dataAttributes'> {
    /** Возможность сворачивания; без значения — настройка приложения `boxCollapseEnabled`. */
    collapseEnabledOverride?: boolean;
    /** Якорь диагностики клиентских формул. */
    formulaTraceTargetId?: string;
}

// Компонент живёт в @srm/ui; обёртка подставляет настройку сворачивания и якорь диагностики формул.
const Box: FC<IBoxProps> = ({ collapseEnabledOverride, formulaTraceTargetId, ...props }: IBoxProps) => (
    <UiBox
        {...props}
        collapseEnabled={collapseEnabledOverride ?? ConfigService.get().application.boxCollapseEnabled}
        dataAttributes={formulaTraceAttrs(formulaTraceTargetId, 'block')}
    />
);

export default Box;
